// extracted by mini-css-extract-plugin
export var charitiesHeaderShort = "styles-module--charities-header-short--1XMoR";